import * as React from 'react';
import InvestorType from 'src/entities/InvestorType';
import '../Modals.css';
import Project from 'src/entities/Project';
import InvestmentFunnelHeaderComponent from './partials/InvestmentFunnelHeader.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { HashLink as Link } from 'react-router-hash-link';

export interface InvestmentInformationComponentProps {
  investorType?: InvestorType;
  project: Project;
  handleClick: () => void;
  modalRef?: Modal;
}

class InvestmentInformationComponent extends React.PureComponent<InvestmentInformationComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="modal-content investment-funnel-modal">
        <InvestmentFunnelHeaderComponent
          logo={this.props.project.company.logo}
          modalRef={this.props.modalRef}
        />
        <div className="modal-body">

          <p className="featured c-black-text">
            Información previa a la inversión:
          </p>
          <div className="gap-10" />
          <p className="padding-left-30">
            <strong className="f-s-22 num">
              A.-
            </strong>
            La operación de financiación participativa no es objeto de autorización ni de supervisión por la Comisión
            Nacional del Mercado de Valores ni por el Banco de España y la información facilitada por el promotor no
            ha sido revisada por ellos.
          </p>
          <div className="gap-10" />
          <p className="padding-left-30">
            <strong className="f-s-22 num">
              B.-
            </strong>
            En el caso de emisión de valores, ésta no es objeto de autorización ni de supervisión por la Comisión
            Nacional del Mercado de Valores y la información facilitada por el emisor no ha sido revisada por la
            Comisión Nacional del Mercado de Valores ni constituye un folleto informativo aprobado por la Comisión
            Nacional del Mercado de Valores.
          </p>
          <div className="gap-10" />
          <p className="padding-left-30">
            <strong className="f-s-22 num">
              C.-
            </strong>
            La existencia de riesgo de pérdida total o parcial del capital invertido, riesgo de no obtener el
            rendimiento dinerario esperado y riesgo de iliquidez para recuperar su inversión.
          </p>
          <div className="gap-10" />
          <p className="padding-left-30">
            <strong className="f-s-22 num">
              D.-
            </strong>
            El capital invertido no está garantizado por el fondo de garantía de inversiones ni por el fondo de
            garantía de depósitos.
          </p>
          {
            this.props.investorType &&
              (
                this.props.investorType.type === 'No acreditado' ||
                this.props.investorType.type === 'Acreditado' &&
                this.props.investorType.accreditationExpired
              ) ?
              <section>
                <div className="gap-10" />
                <p className="padding-left-30">
                  <strong className="f-s-22 num">
                    E.-
                </strong>
                  He sido advertido de los riesgos que implica la inversión en la operación de financiación
                  participativa&nbsp;
                <Link
                  to="/informacion-basica#riesgos"
                  target="_blank"
                >
                    (Advertencia de riesgos)
                </Link>
                  .
              </p>
                <div className="gap-10" />
                <p className="padding-left-30">
                  <strong className="f-s-22 num">
                    F.-
                </strong>
                  Teniendo en cuenta la operación realizada, mi inversión total en los últimos doce meses en operaciones
                  publicadas por el conjunto de plataformas de financiación participativa no supera el umbral de
                  10.000 €.
              </p>
              </section> : null
          }
          <div className="gap-20" />
          <p className="text-center">
            <button
              className="btn btn-secondary"
              onClick={() => this.props.handleClick()}
            >
              Quiero seguir adelante con la inversión
            </button>
          </p>

        </div>
      </div>
    );
  }
}

export default InvestmentInformationComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/InvestmentInformation.component.tsx